<template>
  <DashboardHeader>
    <ReportsDesigner :tables="tables"></ReportsDesigner>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import ReportsDesigner from "@/components/myLibrary/ReportsDesigner.vue";
export default {
  components: { DashboardHeader, ReportsDesigner },

  data() {
    return {
      tables: [
        {
          text: "Contact Us",
          value: "contact_us",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Courts",
          value: "courts",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Court Types",
          value: "court_types",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Deduction Types",
          value: "deduction_types",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Earning Types",
          value: "earning_types",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Events",
          value: "events",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Posts",
          value: "posts",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Products",
          value: "products",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Services",
          value: "services",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
        {
          text: "Statuses",
          value: "case_statuses",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        },
      ],
    };
  },
};
</script>

<style></style>
